@if (!isProcedureValid()) {
  <div class="mx-auto w-3/4 items-center space-y-6 bg-gray-100 p-4 text-center">
    <span
      class="material-icons"
      [attr.aria-label]="'USER_PAGE.ICONS.ERROR_ARIAL_LABEL' | translate"
    >
      error
    </span>
    <h1 class="text-2xl">{{ 'USER_PAGE.WARNING.TITLE' | translate }}</h1>
    <p>
      {{
        'USER_PAGE.WARNING.EXPIRED'
          | translate
            : {
                startDate:
                  (currentUser?.startDate | date: 'dd/MM/yyyy') ?? '--',
                startTime: (currentUser?.startDate | date: 'HH:mm') ?? '--',
                endDate: (currentUser?.endDate | date: 'dd/MM/yyyy') ?? '--',
                endTime: (currentUser?.endDate | date: 'HH:mm') ?? '--',
              }
      }}
    </p>
  </div>
} @else if (isFormCompleted) {
  <div class="mx-auto w-3/4 space-y-6 bg-gray-100 p-4 text-center">
    <div class="flex items-center justify-center">
      <span
        class="material-icons mr-2 text-3xl text-red-500"
        [attr.aria-label]="'USER_PAGE.ICONS.ERROR_ARIAL_LABEL' | translate"
      >
        error
      </span>
      <h1 class="text-2xl">{{ 'USER_PAGE.WARNING.TITLE' | translate }}</h1>
    </div>
    <p>{{ 'USER_PAGE.WARNING.DESCRIPTION' | translate }}</p>
  </div>
} @else {
  @if (sessionExpired()) {
    <div
      class="mx-auto mb-4 w-3/4 space-y-3 bg-yellow-100 p-4 text-center"
      role="alert"
    >
      <p>{{ 'USER_PAGE.FORM.SESSION_EXPIRED' | translate }}</p>
      <button mat-raised-button type="button" (click)="loginAgain()">
        {{ 'USER_PAGE.FORM.LOGIN_AGAIN' | translate }}
      </button>
    </div>
  }
  <mat-stepper
    #stepper
    [linear]="true"
    (selectionChange)="onStepChange($event, stepper)"
    class="!bg-white"
    role="tablist"
    [attr.aria-label]="'USER_PAGE.STEPPER.STEPPER_ARIAL_LABEL' | translate"
  >
    <mat-step
      [stepControl]="privacyForm"
      [editable]="!isFormLocked"
      role="tab"
      [attr.aria-label]="
        'USER_PAGE.STEPPER.PRIVACY_FORM.PRIVACY_FORM_ARIA_LABEL' | translate
      "
      aria-controls="privacyPanelContent"
      id="privacyTab"
    >
      <form [formGroup]="privacyForm">
        <ng-template matStepLabel>
          {{ 'USER_PAGE.STEPPER.PRIVACY_FORM.TITLE' | translate }}
        </ng-template>
        @if (isStepLoading(stepIndexes.PRIVACY_POLICY)) {
          <div class="flex justify-center bg-gray-100 p-8" aria-live="polite">
            <mat-spinner diameter="32" />
          </div>
        } @else if (hasLoadError(stepIndexes.PRIVACY_POLICY)) {
          <div class="space-y-3 bg-gray-100 p-4" role="alert">
            <p>{{ 'USER_PAGE.FORM.LOAD_ERROR' | translate }}</p>
            <button
              mat-button
              (click)="retryLoadStep(stepIndexes.PRIVACY_POLICY)"
            >
              {{ 'USER_PAGE.FORM.RETRY' | translate }}
            </button>
          </div>
        } @else {
          <div
            class="mx-2 space-y-6 bg-gray-100 p-4 sm:mx-4"
            role="tabpanel"
            id="privacyPanelContent"
            aria-labelledby="privacyTab"
          >
            <personal-info [currentUser]="currentUser" />
            <div>
              @for (
                form of getForms(privacyForm).controls;
                track formIndex;
                let formIndex = $index
              ) {
                @for (
                  field of getFields(form).controls;
                  track fieldIndex;
                  let fieldIndex = $index
                ) {
                  <mat-checkbox
                    [formControl]="$any(field.get('value'))"
                    required
                  >
                    {{
                      'USER_PAGE.STEPPER.PRIVACY_FORM.TERMS_AND_CONDITIONS.ACCEPT'
                        | translate
                    }}
                  </mat-checkbox>
                }
              }
            </div>
            <button
              mat-button
              (click)="updateForm(privacyForm, stepper)"
              [disabled]="
                !privacyForm.valid ||
                isUpdatingForm ||
                isSubmitting ||
                sessionExpired()
              "
            >
              <mat-spinner
                *ngIf="isUpdatingForm"
                diameter="20"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  margin-right: 8px;
                "
              ></mat-spinner>
              <span>{{ 'USER_PAGE.STEPPER.ACTIONS.NEXT' | translate }}</span>
            </button>
          </div>
        }
      </form>
    </mat-step>
    <mat-step
      [stepControl]="workingExperienceForm"
      [editable]="!isFormLocked"
      role="tab"
      [attr.aria-label]="
        'USER_PAGE.STEPPER.WORKING_EXPERIENCE.WORKING_EXPERIENCE_ARIA_LABEL'
          | translate
      "
      aria-controls="workingPanelContent"
      id="workingExperienceTab"
    >
      <form
        [formGroup]="workingExperienceForm"
        (ngSubmit)="$event.preventDefault()"
      >
        <ng-template matStepLabel>
          {{ 'USER_PAGE.STEPPER.WORKING_EXPERIENCE.TITLE' | translate }}
        </ng-template>
        @if (isStepLoading(stepIndexes.WORKING_EXPERIENCE)) {
          <div class="flex justify-center bg-gray-100 p-8" aria-live="polite">
            <mat-spinner diameter="32" />
          </div>
        } @else if (hasLoadError(stepIndexes.WORKING_EXPERIENCE)) {
          <div class="space-y-3 bg-gray-100 p-4" role="alert">
            <p>{{ 'USER_PAGE.FORM.LOAD_ERROR' | translate }}</p>
            <button
              mat-button
              (click)="retryLoadStep(stepIndexes.WORKING_EXPERIENCE)"
            >
              {{ 'USER_PAGE.FORM.RETRY' | translate }}
            </button>
          </div>
        } @else {
          <div
            class="mx-2 bg-gray-100 p-4 sm:mx-4"
            role="tabpanel"
            id="workingPanelContent"
            aria-labelledby="workingExperienceTab"
          >
            <div
              class="flex flex-col gap-6 lg:flex-row"
              (focusout)="onPreviewAreaBlur($event)"
            >
              <div class="min-w-0 flex-1 space-y-6">
                @for (
                  form of getForms($any(workingExperienceForm)).controls;
                  track formIndex;
                  let formIndex = $index
                ) {
                  <h1 class="bg-blue-900 text-lg text-white">
                    {{
                      'USER_PAGE.STEPPER.WORKING_EXPERIENCE.' +
                        form.value.section_name.toUpperCase() | translate
                    }}
                  </h1>
                  <div [hidden]="form.value.section_name !== 'service_length'">
                    <h2 class="text-sm">
                      {{
                        'USER_PAGE.STEPPER.WORKING_EXPERIENCE.SERVICE_SENIORITY'
                          | translate
                      }}
                    </h2>
                    <mat-divider />
                  </div>
                  @if (form.value.section_name === 'activities') {
                    @for (
                      field of getFields($any(form)).controls;
                      track fieldIndex;
                      let fieldIndex = $index
                    ) {
                      <div class="mb-4 flex items-start gap-x-4">
                        <div class="w-full">
                          <label
                            class="mb-1 block text-sm text-gray-700"
                            [for]="field.value.id"
                          >
                            {{ field.value.label }}
                            <span>
                              {{
                                'USER_PAGE.STEPPER.WORKING_EXPERIENCE.MAX_CHARS'
                                  | translate: { maxChars: 4000 }
                              }}
                            </span>
                          </label>
                          <mat-form-field class="w-full">
                            <input
                              [id]="field.value.id"
                              matInput
                              [formControl]="$any(field.get('value'))"
                              [required]="field.value.required"
                              (focus)="
                                openPreview(
                                  field.value,
                                  'value',
                                  $any(field.get('value'))
                                )
                              "
                            />
                            <mat-error
                              *ngIf="
                                $any(field.get('value')).hasError('maxlength')
                              "
                            >
                              {{
                                'USER_PAGE.VALIDATION.MAX_LENGTH'
                                  | translate: { maxChars: 4000 }
                              }}
                            </mat-error>
                            <mat-error
                              *ngIf="
                                $any(field.get('value')).hasError('required')
                              "
                            >
                              {{ 'USER_PAGE.VALIDATION.REQUIRED' | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    }
                  } @else {
                    @for (
                      field of getFields($any(form)).controls;
                      track fieldIndex;
                      let fieldIndex = $index
                    ) {
                      <div
                        class="mb-4 grid grid-cols-1 items-start gap-x-4 gap-y-2 md:grid-cols-[minmax(0,1fr)_minmax(0,1.25fr)]"
                      >
                        <div
                          class="grid min-w-0 grid-cols-[minmax(0,1fr)_auto] items-start gap-2"
                        >
                          <div>
                            <label
                              class="mb-1 block text-sm text-gray-700"
                              [for]="field.value.id"
                            >
                              {{ field.value.label }}
                            </label>
                            <mat-form-field class="w-full">
                              <input
                                #serviceDateInput
                                [id]="field.value.id"
                                matInput
                                [formControl]="$any(field.get('value'))"
                                [required]="field.value.required"
                                (focus)="
                                  openPreview(
                                    field.value,
                                    'value',
                                    $any(field.get('value'))
                                  )
                                "
                              />
                              <mat-error
                                *ngIf="
                                  $any(field.get('value')).hasError('maxlength')
                                "
                              >
                                {{
                                  'USER_PAGE.VALIDATION.MAX_LENGTH'
                                    | translate: { maxChars: 4000 }
                                }}
                              </mat-error>
                              <mat-error
                                *ngIf="
                                  $any(field.get('value')).hasError('required')
                                "
                              >
                                {{
                                  'USER_PAGE.VALIDATION.REQUIRED' | translate
                                }}
                              </mat-error>
                            </mat-form-field>
                            @if (
                              getSeniorityDateValidationMessage(field);
                              as validationMessage
                            ) {
                              <p
                                class="-mt-4 text-sm text-red-700"
                                role="alert"
                              >
                                {{ validationMessage | translate }}
                              </p>
                            }
                          </div>
                          @if (field.value['can_edit']) {
                            <button
                              type="button"
                              mat-icon-button
                              (click)="
                                openNotes(
                                  fieldIndex,
                                  field.value['name'],
                                  serviceDateInput
                                )
                              "
                              [attr.aria-label]="
                                'USER_PAGE.STEPPER.ACTIONS.EDIT_DATE_ARIA_LABEL'
                                  | translate
                              "
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                          }
                        </div>

                        @if (field.value['can_edit']) {
                          @if (field.value['notes']['text'] || field.enabled) {
                            <div
                              class="grid min-w-0 grid-cols-[minmax(0,1fr)_1.75rem] items-end gap-x-2"
                            >
                              <label
                                class="col-start-1 mb-1 block text-sm text-gray-700"
                                [for]="field.value.id + '-notes'"
                              >
                                <span>
                                  {{
                                    'USER_PAGE.STEPPER.WORKING_EXPERIENCE.NOTES_FOR_FIELD'
                                      | translate: { label: field.value.label }
                                  }}
                                </span>
                                @if (
                                  getNotesMaxLength(field.value.name);
                                  as maxChars
                                ) {
                                  <span>
                                    {{
                                      'USER_PAGE.STEPPER.WORKING_EXPERIENCE.MAX_CHARS'
                                        | translate: { maxChars }
                                    }}
                                  </span>
                                }
                              </label>
                              <mat-form-field class="col-start-1 w-full">
                                <input
                                  [id]="field.value.id + '-notes'"
                                  matInput
                                  [formControl]="$any(field.get('notes.text'))"
                                  [maxLength]="
                                    getNotesMaxLength(field.value.name)
                                  "
                                  required
                                  (focus)="
                                    openPreview(
                                      field.value,
                                      'notes.text',
                                      $any(field.get('notes.text'))
                                    )
                                  "
                                />
                                <mat-error
                                  *ngIf="
                                    $any(field.get('notes.text')).hasError(
                                      'maxlength'
                                    )
                                  "
                                >
                                  {{
                                    'USER_PAGE.VALIDATION.MAX_LENGTH'
                                      | translate
                                        : {
                                            maxChars: getNotesMaxLength(
                                              field.value.name
                                            ),
                                          }
                                  }}
                                </mat-error>
                                <mat-error
                                  *ngIf="
                                    $any(field.get('notes.text')).hasError(
                                      'required'
                                    )
                                  "
                                >
                                  {{
                                    'USER_PAGE.VALIDATION.REQUIRED' | translate
                                  }}
                                </mat-error>
                              </mat-form-field>

                              @if (field.enabled) {
                                <button
                                  type="button"
                                  mat-icon-button
                                  class="col-start-2 row-start-1 !h-7 !min-h-7 !w-7 !min-w-7 self-start !p-0.5"
                                  style="
                                    --mdc-icon-button-state-layer-size: 1.75rem;
                                  "
                                  (click)="
                                    patchNotes(fieldIndex, field.value.name)
                                  "
                                  [disabled]="
                                    $any(field.get('notes.text')).invalid ||
                                    $any(field.get('value')).invalid
                                  "
                                  [attr.aria-label]="
                                    'USER_PAGE.STEPPER.ACTIONS.SAVE_NOTES_ARIA_LABEL'
                                      | translate
                                  "
                                >
                                  <mat-icon>save</mat-icon>
                                </button>
                              }
                              <button
                                type="button"
                                mat-icon-button
                                class="col-start-2 row-start-2 !h-7 !min-h-7 !w-7 !min-w-7 self-center !p-0.5"
                                style="
                                  --mdc-icon-button-state-layer-size: 1.75rem;
                                "
                                (click)="
                                  restoreValue(fieldIndex, field.value.name)
                                "
                                [attr.aria-label]="
                                  'USER_PAGE.STEPPER.ACTIONS.RESTORE_DATE_ARIA_LABEL'
                                    | translate
                                "
                              >
                                <mat-icon>undo</mat-icon>
                              </button>
                            </div>
                          }
                        }
                      </div>
                    }
                    @if (
                      form.value.section_name === 'service_length' &&
                      hasPendingServiceChange()
                    ) {
                      <mat-error class="-mt-2 block" role="alert">
                        {{
                          'USER_PAGE.STEPPER.WORKING_EXPERIENCE.PENDING_SERVICE_CHANGE'
                            | translate
                        }}
                      </mat-error>
                    }
                  }
                }
                <div>
                  <button
                    mat-button
                    matStepperPrevious
                    [disabled]="
                      hasPendingServiceChange() ||
                      isUpdatingForm ||
                      isSubmitting ||
                      sessionExpired()
                    "
                  >
                    <span>
                      {{ 'USER_PAGE.STEPPER.ACTIONS.BACK' | translate }}
                    </span>
                  </button>
                  <button
                    type="button"
                    mat-button
                    [disabled]="
                      !workingExperienceForm.valid ||
                      hasPendingServiceChange() ||
                      isUpdatingForm ||
                      isSubmitting ||
                      sessionExpired()
                    "
                    (click)="updateForm(workingExperienceForm, stepper)"
                  >
                    <mat-spinner
                      *ngIf="isUpdatingForm"
                      diameter="20"
                      style="
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 8px;
                      "
                    ></mat-spinner>
                    <span>
                      {{ 'USER_PAGE.STEPPER.ACTIONS.NEXT' | translate }}
                    </span>
                  </button>
                </div>
              </div>

              <aside class="w-full self-start lg:sticky lg:top-4 lg:w-[45%]">
                @if (activePreviewLabel()) {
                  <div
                    id="activePreviewLabel"
                    class="mb-1 text-sm font-semibold text-gray-700"
                  >
                    {{
                      'USER_PAGE.STEPPER.WORKING_EXPERIENCE.PREVIEW'
                        | translate: { label: activePreviewLabel() }
                    }}
                  </div>
                  <div
                    role="textbox"
                    tabindex="0"
                    aria-readonly="true"
                    aria-labelledby="activePreviewLabel"
                    [textContent]="activePreviewValue()"
                    class="min-h-40 w-full rounded border border-gray-300 bg-gray-50 p-3 text-sm break-words whitespace-pre-wrap text-gray-700 outline-none"
                  ></div>
                }
              </aside>
            </div>
          </div>
        }
      </form>
    </mat-step>
    <mat-step
      [editable]="!isFormLocked"
      role="tab"
      [attr.aria-label]="
        'USER_PAGE.STEPPER.CONCLUSION.CONCLUSION_ARIA_LABEL' | translate
      "
      aria-controls="conclusionPanelContent"
      aria-selected="true"
      id="conclusionTab"
    >
      <ng-template matStepLabel>
        {{ 'USER_PAGE.STEPPER.CONCLUSION.TITLE' | translate }}
      </ng-template>
      <div
        class="mx-2 space-y-6 bg-gray-100 p-4 sm:mx-4"
        role="tabpanel"
        id="conclusionPanelContent"
        aria-labelledby="conclusionTab"
      >
        @if (!submissionCompleted) {
          <div class="mx-auto max-w-4xl text-center">
            <h1 class="mb-4 text-2xl">
              {{ 'USER_PAGE.STEPPER.CONCLUSION.CONFIRM_TITLE' | translate }}
            </h1>
            <p
              class="text-lg"
              [innerHTML]="'USER_PAGE.STEPPER.CONCLUSION.RESUME' | translate"
            ></p>
          </div>

          <div class="mt-8 flex justify-center">
            <button
              mat-button
              matStepperPrevious
              color="primary"
              [disabled]="isSubmitting || isUpdatingForm || sessionExpired()"
            >
              {{ 'USER_PAGE.STEPPER.ACTIONS.BACK' | translate }}
            </button>
            <button
              mat-raised-button
              (click)="submitForm(workingExperienceForm)"
              [disabled]="
                !workingExperienceForm.valid ||
                isSubmitting ||
                isUpdatingForm ||
                sessionExpired()
              "
              class="bg-primary! ml-4 text-white!"
            >
              <div class="flex items-center gap-2">
                @if (isSubmitting) {
                  <mat-progress-spinner
                    mode="indeterminate"
                    diameter="20"
                    class="white-spinner"
                    [attr.aria-label]="
                      'USER_PAGE.STEPPER.ACTIONS.SUBMIT_PROGRESS_SPINNER_ARIA_LABEL'
                        | translate
                    "
                  ></mat-progress-spinner>
                }
                <span>
                  <b>
                    {{ 'USER_PAGE.STEPPER.ACTIONS.SEND_RESULTS' | translate }}
                  </b>
                </span>
              </div>
            </button>
          </div>
        } @else {
          <p>
            {{ 'USER_PAGE.STEPPER.CONCLUSION.RESULT' | translate }}
          </p>
        }
      </div>
    </mat-step>
  </mat-stepper>
}
